import React from 'react'
import Skeleton from 'react-loading-skeleton'

import PageSection from '../PageSection'

import useStyles from './styles'

function SkeletonSummaryReport() {
  const classes = useStyles()

  const SkeletonGraphSection = (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>
          <Skeleton width={80} height={17} />
        </div>
      </div>
      <Skeleton height={180} style={{ width: '100%', marginTop: 5 }} />
    </PageSection>
  )

  return (
    <>
      <div className={classes.graphsContainer}>
        {SkeletonGraphSection}
        {SkeletonGraphSection}
        {SkeletonGraphSection}
        {SkeletonGraphSection}
        {SkeletonGraphSection}
        {SkeletonGraphSection}
      </div>
    </>
  )
}

export default SkeletonSummaryReport
